import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { authService } from "../../services/authService";
import { toast } from "react-toastify";
import "./login.css";

const ForgetPassword = () => {
  const [email, setEmail] = useState("");
  const [step, setStep] = useState(1); // 1: email input, 2: show masked phone
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleEmailSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      toast.error("Email is required");
      return;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address");
      return;
    }

    setLoading(true);
    try {
      const response = await authService.forgetPassword({ email });

      if (response.success) {
        // If requires confirmation (old flow), handle it
        if (response.data?.requires_confirmation) {
          setUserData(response.data);
          setStep(2);
          toast.info("Please confirm your phone number");
        } else {
          // New flow: OTP already sent, show masked phone and navigate
          setUserData(response.data);
          toast.success(response.message || "OTP sent to your phone number");

          // Navigate to OTP verification page
          navigate("/verify-otp", {
            state: {
              identifier: response.data.phone,
              method: "phone",
              user_type: response.data.user_type,
              email: email,
              masked_phone: response.data.masked_phone,
            },
          });
        }
      } else {
        toast.error(response.message || "Failed to send OTP");
      }
    } catch (error) {
      console.error("Forget password error:", error);
      toast.error(
        error.response?.data?.message ||
          error.message ||
          "Failed to send OTP. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmAndSendOTP = async () => {
    if (!userData?.phone) {
      toast.error("Phone number not available");
      return;
    }

    setLoading(true);
    try {
      // Send OTP to the phone
      const response = await authService.forgetPassword({
        email: email,
        phone: userData.phone,
      });

      if (response.success) {
        toast.success(response.message || "OTP sent to your phone number");

        // Navigate to OTP verification page
        navigate("/verify-otp", {
          state: {
            identifier: userData.phone,
            method: "phone",
            user_type: userData.user_type,
            email: email,
            masked_phone: userData.masked_phone,
          },
        });
      } else {
        toast.error(response.message || "Failed to send OTP");
      }
    } catch (error) {
      console.error("Send OTP error:", error);
      toast.error(
        error.response?.data?.message ||
          error.message ||
          "Failed to send OTP. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        {/* Left Illustration */}
        <div className="login-left">
          <img src={process.env.PUBLIC_URL + "/login_page.jpg"} alt="Illustration" />
        </div>

        {/* Right Form */}
        <div className="login-right">
          <div className="logo-container">
            <img src={process.env.PUBLIC_URL + "/pickloo.jpeg"} alt="Pickloo Logo" className="logo" />
          </div>

          {step === 1 ? (
            <>
              <h2>Forgot Password</h2>
              <p>Enter your email address to reset password</p>

              <form onSubmit={handleEmailSubmit}>
                <div className="form-group">
                  <label>Email Address</label>
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                    required
                  />
                  <small
                    style={{
                      color: "#666",
                      fontSize: "12px",
                      marginTop: "5px",
                      display: "block",
                    }}
                  >
                    We'll send OTP to your registered phone number
                  </small>
                </div>

                <button type="submit" className="login-btn" disabled={loading}>
                  {loading ? "Checking..." : "Continue"}
                </button>
              </form>
            </>
          ) : (
            <>
              <h2>Confirm Phone Number</h2>
              <p>OTP will be sent to your registered phone number</p>

              <div style={{ marginBottom: "20px" }}>
                <div
                  style={{
                    background: "#f5f5f5",
                    padding: "15px",
                    borderRadius: "8px",
                    textAlign: "center",
                    marginBottom: "20px",
                  }}
                >
                  <p style={{ margin: "0", color: "#666", fontSize: "14px" }}>
                    Phone Number:
                  </p>
                  <p
                    style={{
                      margin: "5px 0 0 0",
                      color: "#333",
                      fontSize: "18px",
                      fontWeight: "bold",
                      letterSpacing: "2px",
                    }}
                  >
                    {userData?.masked_phone || "XXXXXX4272"}
                  </p>
                </div>

                <button
                  type="button"
                  className="login-btn"
                  onClick={handleConfirmAndSendOTP}
                  disabled={loading}
                >
                  {loading ? "Sending OTP..." : "Send OTP"}
                </button>
              </div>
            </>
          )}

          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <button
              type="button"
              onClick={() => {
                if (step === 2) {
                  setStep(1);
                  setUserData(null);
                } else {
                  navigate("/login");
                }
              }}
              style={{
                background: "none",
                border: "none",
                color: "#333",
                cursor: "pointer",
                textDecoration: "underline",
                fontSize: "14px",
              }}
            >
              {step === 2 ? "Change Email" : "Back to Login"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgetPassword;
